import {isDesktop} from "../../webpack/modules/devices";
import {
    clickEvent,
    customEvent,
    documentLoadEvent,
    mouseEnterEvent,
    windowScrollEvent
} from "../../webpack/modules/events";
import {onVisible} from "../Tools/visible-element-observer";
import {ga4TrackSimpleEvent} from "../../webpack/modules/analytics";
import {hideOffcanvasByDomObject, showOffcanvasByDomObject} from "../../webpack/modules/offcanvas";
import {hideLoader, showLoader} from "../../webpack/modules-optimized/offcanvas";
import {getMenuHtmlById, getMenusHtmlByIds} from "../../webpack/modules-optimized/left-menu";

documentLoadEvent(function () {
    replaceCountryLinks();
    loadAutoloadMenus();
});
if (document.querySelector('#left-menu.left-menu-v2')) onVisible(document.querySelectorAll("#left-menu.left-menu-v2 #left-menu-country-selector img"), (image) => image.src = image.dataset.src);
if (document.querySelector('#left-menu.left-menu-v2')) initHoverOpenMenuButtonsEvent();

if (document.querySelector('.left-menu-v2')) {
    if (isDesktop()) {
        calculateLeftMenuHeight();

        let headerMessagesVisible = false;
        windowScrollEvent(function() {
            let headerMessages = document.querySelector('.header-messages');
            if (!headerMessages) return;
            let rect = headerMessages.getBoundingClientRect();
            let currentHeaderMessagesVisible = rect.top < window.innerHeight && rect.bottom > 0;

            //RECALCULATE LEFT MENU HEIGHT ONLY IF VISIBILITY CHANGED
            if (headerMessagesVisible !== currentHeaderMessagesVisible) {
                headerMessagesVisible = currentHeaderMessagesVisible;
                if (headerMessagesVisible) calculateLeftMenuHeight();
                else calculateLeftMenuHeightWithoutMessages();
            }
        });
    }
}

let backdropHoverTimeout;
let openLeftMenuTimeout;

customEvent('show.bs.offcanvas', '.left-menu-v2', false, function(leftMenu) {
    if (isDesktop()) {
        setTimeout(function() {
            let backdrop = document.querySelector('.offcanvas-backdrop');
            backdrop.style.height = leftMenu.style.height;
            backdrop.style.top = 'inherit';
            backdrop.style.bottom = '0';
            backdrop.addEventListener('mouseenter', backdropMouseEnterHandler);
        }, 1);
    }
});

mouseEnterEvent('.left-menu-v2', false, function() {
    if (backdropHoverTimeout) clearTimeout(backdropHoverTimeout);
    if (openLeftMenuTimeout) clearTimeout(openLeftMenuTimeout);
});

customEvent('hidden.bs.offcanvas', '.left-menu-v2:not(.left-menu-main-level)', false, function(leftMenu) {
    leftMenu.querySelectorAll('nav.show').forEach((navToHide) => navToHide.classList.remove('show'));
});

customEvent('hide.bs.offcanvas', '.left-menu-main-level', false, function() {
    let secondLevelOffcanvas = document.querySelector('.left-menu-v2.left-menu-second-level.show');
    let thirdLevelOffcanvas = document.querySelector('.left-menu-v2.left-menu-third-level.show');
    let backdrop = document.querySelector('.offcanvas-backdrop');

    if (secondLevelOffcanvas) hideOffcanvasByDomObject(secondLevelOffcanvas);
    if (thirdLevelOffcanvas) hideOffcanvasByDomObject(thirdLevelOffcanvas);
    if (backdrop) backdrop.removeEventListener('mouseenter', backdropMouseEnterHandler);

    ga4TrackSimpleEvent({event: 'header_menu', method: 'close'});
    clearTimeout(openLeftMenuTimeout);
});

clickEvent('.left-menu-v2 .open-menu', true, function(button) {
    openLeftMenu(button);
});

clickEvent('.left-menu-v2 .go-back-menu', true, function(button) {
    let currentOffcanvas = button.closest('.offcanvas.left-menu-v2');
    let currentNav = currentOffcanvas.querySelector('nav.show');
    let previousNav = document.querySelector(`.left-menu-v2 .open-menu[data-next-menu="${currentNav.dataset.id}"]`).closest('nav');
    let previousOffcanvas = previousNav.closest('.offcanvas.left-menu-v2');

    currentNav.classList.remove('show');
    previousNav.classList.add('show');
    hideOffcanvasByDomObject(currentOffcanvas);
    showOffcanvasByDomObject(previousOffcanvas);
    ga4TrackSimpleEvent({event: 'header_menu', method: 'back'});
});

customEvent('shown.bs.collapse', '#left-menu-country-selector', false, function() {
    ga4TrackSimpleEvent({event: 'header_country_selector', method: 'open'});
});

customEvent('hidden.bs.collapse', '#left-menu-country-selector', false, function() {
    ga4TrackSimpleEvent({event: 'header_country_selector', method: 'close'});
});

clickEvent('.outer-menu-open', true, function() {
    let leftMenuOpened = document.querySelector('#left-menu.show');
    if (leftMenuOpened) hideOffcanvasByDomObject(leftMenuOpened);
});

mouseEnterEvent('form.search-form input, header .header-dropdown, header .open-cart, .header-messages', false, function() {
    let leftMenuOpened = document.querySelector('#left-menu.show');
    if (leftMenuOpened) hideOffcanvasByDomObject(leftMenuOpened);
});

function replaceCountryLinks()
{
    let leftMenu = document.querySelector('#left-menu.left-menu-v2');
    if (!leftMenu) return;
    let alternates = document.querySelectorAll('link[rel=alternate]');
    alternates.forEach(function(alternate) {
        let hreflang = alternate.getAttribute('hreflang');
        let locale = hreflang.replace("-","_");
        let href = alternate.getAttribute('href');
        let link = leftMenu.querySelector(`.website-selector[data-locale=${locale}]`);
        if (link) link.setAttribute("href", href);
    });
}

function initHoverOpenMenuButtonsEvent()
{
    if (!isDesktop()) return;
    let buttons = document.querySelectorAll('.left-menu-v2 .open-menu');
    let links = document.querySelectorAll('.left-menu-v2 .link-item a');

    buttons.forEach(function (button) {
        if (button.addedHoverEvent) return;

        button.addEventListener('mouseenter', function() {
            if (openLeftMenuTimeout) clearTimeout(openLeftMenuTimeout);
            openLeftMenuTimeout = setTimeout(function() {
                openLeftMenu(button);
            }, 300);
        });

        button.addedHoverEvent = true;
    });

    links.forEach(function(link) {
        if (link.addedHoverEvent) return;

        link.addEventListener('mouseenter', function() {
            let offcanvas = link.closest('.left-menu-v2');
            if (openLeftMenuTimeout) clearTimeout(openLeftMenuTimeout);
            let secondLevelOffcanvas = document.querySelector('.left-menu-v2.left-menu-second-level.show');
            let thirdLevelOffcanvas = document.querySelector('.left-menu-v2.left-menu-third-level.show');

            if (offcanvas.classList.contains('left-menu-main-level')) {
                if (thirdLevelOffcanvas) hideOffcanvasByDomObject(thirdLevelOffcanvas);
                if (secondLevelOffcanvas) hideOffcanvasByDomObject(secondLevelOffcanvas);
                // setTimeout(function() {
                //     document.body.style.overflow = 'hidden';
                //     document.body.style.paddingRight = '15px';
                // }, 40);
            }

            if (offcanvas.classList.contains('left-menu-second-level')) {
                if (thirdLevelOffcanvas) hideOffcanvasByDomObject(thirdLevelOffcanvas);
            }

            link.addedHoverEvent = true;
        });
    });
}

async function openLeftMenu(button)
{
    let menuId = button.dataset.nextMenu;
    let currentOffcanvas = button.closest('.left-menu-v2');
    let isDynamic = currentOffcanvas.classList.contains('left-menu-dynamic');
    let nextOffcanvas = null;

    if (currentOffcanvas.classList.contains('left-menu-main-level')) nextOffcanvas = document.querySelector('.left-menu-v2.left-menu-second-level');
    if (currentOffcanvas.classList.contains('left-menu-second-level')) nextOffcanvas = document.querySelector('.left-menu-v2.left-menu-third-level');

    if (!nextOffcanvas) return;
    if (nextOffcanvas.querySelector(`.left-menu-v2 nav[data-id="${menuId}"].show`)) return;

    if (nextOffcanvas.classList.contains('left-menu-second-level') && isDesktop()) {
        let thirdLevelOffcanvas = document.querySelector('.left-menu-v2.left-menu-third-level.show');
        if (thirdLevelOffcanvas) hideOffcanvasByDomObject(thirdLevelOffcanvas);
    }

    if (isDynamic) {
        nextOffcanvas.querySelector('.offcanvas-body .container-fluid').innerHTML = '';
        nextOffcanvas.querySelector('.offcanvas-title').innerHTML = '';
        if (!isDesktop()) hideOffcanvasByDomObject(currentOffcanvas);
        showOffcanvasByDomObject(nextOffcanvas, {backdrop: !isDesktop()});
        showLoader(nextOffcanvas);
        let menuHtml = await getMenuHtmlById(menuId);
        if (!menuHtml) return;
        nextOffcanvas.querySelector('.offcanvas-body .container-fluid').innerHTML = menuHtml;
    }

    let nav = nextOffcanvas.querySelector(`.left-menu-v2 nav[data-id="${menuId}"]`);
    let title = nav.dataset.title;

    if (nav.classList.contains('show')) return;

    nextOffcanvas.querySelectorAll('nav.show').forEach((navToHide) => navToHide.classList.remove('show'));
    nextOffcanvas.querySelector('.offcanvas-title').innerHTML = title;
    nav.classList.add('show');

    if (isDesktop()) {
        if (!nextOffcanvas.classList.contains('show')) showOffcanvasByDomObject(nextOffcanvas, {backdrop: false});
        if (isDynamic) {
            initHoverOpenMenuButtonsEvent();
            hideLoader(nextOffcanvas);
        }
    } else {
        if (isDynamic) {
            hideLoader(nextOffcanvas);
        } else {
            hideOffcanvasByDomObject(currentOffcanvas);
            showOffcanvasByDomObject(nextOffcanvas);
        }
    }

    ga4TrackSimpleEvent(
        {
            event: 'header_menu',
            method: 'navigate',
            link_id: currentOffcanvas.classList.contains('left-menu-main-level') ? 'from-main' : 'from-submenu',
            link_text: title.toLowerCase()
        }
    );
}

function loadAutoloadMenus()
{
    document.querySelectorAll('.left-menu-v2.autoload-left-menu').forEach(async function(leftMenu) {
        let menusIds = leftMenu.dataset.menuIds;
        if (!menusIds) return;
        let html = await getMenusHtmlByIds(menusIds);
        if (!html) return;
        leftMenu.querySelector('.offcanvas-body .container-fluid').innerHTML = html;
        initHoverOpenMenuButtonsEvent();
    });
}

function calculateLeftMenuHeight()
{
    document.querySelectorAll('.left-menu-v2').forEach(function(leftMenu) {
        let header = document.querySelector('header');
        let headerMessages = document.querySelector('.header-messages');
        let headerHeight = header.offsetHeight;

        if (headerMessages) headerHeight += headerMessages.offsetHeight;
        leftMenu.style.height = (window.innerHeight - headerHeight) + 'px';
    });
}

function calculateLeftMenuHeightWithoutMessages()
{
    document.querySelectorAll('.left-menu-v2').forEach(function(leftMenu) {
        let header = document.querySelector('header');
        let headerHeight = header.offsetHeight;
        leftMenu.style.height = (window.innerHeight - headerHeight) + 'px';
    });
}

function backdropMouseEnterHandler()
{
    if (backdropHoverTimeout) clearTimeout(backdropHoverTimeout);
    backdropHoverTimeout = setTimeout(function() {
        let mainLevelOffcanvas = document.querySelector('.left-menu-v2.left-menu-main-level.show');
        let secondLevelOffcanvas = document.querySelector('.left-menu-v2.left-menu-second-level.show');
        let thirdLevelOffcanvas = document.querySelector('.left-menu-v2.left-menu-third-level.show');

        if (mainLevelOffcanvas) hideOffcanvasByDomObject(mainLevelOffcanvas);
        if (secondLevelOffcanvas) hideOffcanvasByDomObject(secondLevelOffcanvas);
        if (thirdLevelOffcanvas) hideOffcanvasByDomObject(thirdLevelOffcanvas);
    }, 300);
}